'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$77() {
  this.bo8 = null;
  this.bo9 = false;
}
export { $c_Lpresto_PrestoRouter$$anon$77 as $c_Lpresto_PrestoRouter$$anon$77 };
$p = $c_Lpresto_PrestoRouter$$anon$77.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$77;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$77() {
}
export { $h_Lpresto_PrestoRouter$$anon$77 as $h_Lpresto_PrestoRouter$$anon$77 };
$h_Lpresto_PrestoRouter$$anon$77.prototype = $p;
$p.c1 = (function() {
  if ((!this.bo9)) {
    this.bo8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bo9 = true;
  }
  return this.bo8;
});
$p.P = (function() {
  return this.c1();
});
var $d_Lpresto_PrestoRouter$$anon$77 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$77, "presto.PrestoRouter$$anon$77", ({
  OT: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$77 as $d_Lpresto_PrestoRouter$$anon$77 };
//# sourceMappingURL=presto.-Presto-Router$$anon$77.js.map
